import { render, staticRenderFns } from "./RestoreTemplateVersion.vue?vue&type=template&id=21ccb8cb&scoped=true"
import script from "./RestoreTemplateVersion.vue?vue&type=script&lang=ts&setup=true"
export * from "./RestoreTemplateVersion.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./RestoreTemplateVersion.vue?vue&type=style&index=0&id=21ccb8cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ccb8cb",
  null
  
)

export default component.exports